export default __webpack_public_path__ + "static/media/Thaumaturge's Robes of the Mandate.5873c05d.jpg";